"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _coreBaseProps = require("@vfuk/core-base-props");
var _coreTextInput = _interopRequireDefault(require("@vfuk/core-text-input"));
var _coreFieldWrapper = _interopRequireDefault(require("@vfuk/core-field-wrapper"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var TextInputWithLabel = function TextInputWithLabel(_ref) {
  var state = _ref.state,
    fieldWrapper = _ref.fieldWrapper,
    textInput = _ref.textInput,
    id = _ref.id,
    dataAttributes = _ref.dataAttributes,
    dataSelectorPrefix = _ref.dataSelectorPrefix;
  var componentName = 'TextInputWithLabel';
  return /*#__PURE__*/_react["default"].createElement(_coreFieldWrapper["default"], {
    id: id,
    dataAttributes: dataAttributes,
    state: state,
    label: fieldWrapper.label,
    formElementId: textInput.id,
    showLabel: fieldWrapper.showLabel,
    helpText: fieldWrapper.helpText,
    stateText: fieldWrapper.stateText,
    subText: fieldWrapper.subText,
    validateOn: fieldWrapper.validateOn,
    width: fieldWrapper.width,
    helpLink: fieldWrapper.helpLink,
    optional: fieldWrapper.optional,
    required: fieldWrapper.required,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix),
    componentName: componentName
  }, /*#__PURE__*/_react["default"].createElement(_coreTextInput["default"], {
    state: state,
    autoComplete: textInput.autoComplete,
    autoCapitalize: textInput.autoCapitalize,
    dataAttributes: textInput.dataAttributes,
    id: textInput.id,
    name: textInput.name,
    onBlur: textInput.onBlur,
    onChange: textInput.onChange,
    onClick: textInput.onClick,
    placeholder: textInput.placeholder,
    required: textInput.required,
    type: textInput.type,
    value: textInput.value,
    pattern: textInput.pattern,
    spellcheck: textInput.spellcheck,
    minLength: textInput.minLength,
    maxLength: textInput.maxLength,
    onKeyDown: textInput.onKeyDown,
    beforeChange: textInput.beforeChange,
    infieldIcon: textInput.infieldIcon,
    domRef: textInput.domRef,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'text-input')
  }));
};
TextInputWithLabel.displayName = "TextInputWithLabel";
var _default = TextInputWithLabel;
exports["default"] = _default;